import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {
  AuthService, ApiErrorHandlerService, NotificationService, EnvironmentService, DialogService,
  PermissionService, ConstantsService, Contents
} from '@app/core';
import { filter } from 'rxjs/operators';
import { DeveloperService } from '@app/core/services/developer.service';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit {

  public get notificationItems$() { return this.notificationService.notificationItems$; }

  public environment = 'prd';

  constructor(
    private authService: AuthService,
    private apiErrorHandler: ApiErrorHandlerService,
    private notificationService: NotificationService,
    protected router: Router,
    public developerService: DeveloperService,
    environmentService: EnvironmentService,
    private dialogService: DialogService,
    public permissionService: PermissionService,
    protected constants: ConstantsService,
  ) {
    // 緊急停止されているPlatformを取得
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(_ => this.notificationService.reload());

    this.environment = environmentService.ENV || 'prd';
  }

  public logout() {
    const message = 'ログアウトに失敗しました。';
    const size = 'modal-sm';
    this.authService.logout().subscribe(
      _ => this.apiErrorHandler.runSessionErrorAction('ログアウトしました。'),
      _ => this.dialogService.openAlert(message, size)
    );
  }

  public isDeliverySetActive() {
    return this.router.url.startsWith('/delivery_sets')
      || this.router.url.startsWith('/delivery_sets/batch');
  }

  public isDesignTemplateActive() {
    return this.router.url.startsWith('/design_templates')
      || this.router.url.startsWith('/standard_design_templates');
  }

    /**
   * メニューバー>プレースメント設定
   * @remarks
   * 今のルートが「プレースメント設定」または「プレースメント設定一括登録」か
   * どうかを判断する。
   * @returns
   * 現在のURLが「プレースメント設定」または「プレースメント設定一括登録」である場合は true
   * その他の場合は false
   */
  public isPlacementRelationActive() {
    return this.router.url.startsWith('/placement_relations')
      || this.router.url.startsWith('/placement_relations/batch');
  }

  /**
   * メニューバー>配信PF予約登録
   * @remarks
   * 今のルートが「配信PF予約登録」または「配信PF予約一括登録」か
   * どうかを判断する。
   * @returns
   * 現在のURLが「配信PF予約登録」または「配信PF予約一括登録」である場合は true
   * その他の場合は false
   */
  public isPlatformReservationActive() {
    return this.router.url.startsWith('/platform_reservations')
      || this.router.url.startsWith('/platform_reservations/batch');
  }

  public isMasterManagerActive() {
    return this.router.url.startsWith('/tester_devices')
      || this.router.url.startsWith('/device_models')
      || this.router.url.startsWith('/device_model_groups')
      || this.router.url.startsWith('/operating_systems')
      || this.router.url.startsWith('/os_groups')
      || this.router.url.startsWith('/platform_os_groups')
      || this.router.url.startsWith('/sdk_versions')
      || this.router.url.startsWith('/sdk_version_groups')
      || this.router.url.startsWith('/platform_sdk_version_groups')
      || this.router.url.startsWith('/deals')
      || this.router.url.startsWith('/exchange_rates')
      || this.router.url.startsWith('/topics_urls')
      || this.router.url.startsWith('/ad_request_parameter_templates')
      || this.router.url.startsWith('/users');
  }

  public isConfigurationActive() {
    return this.router.url.startsWith('/emergency_stop')
      || this.router.url.startsWith('/platforms/keys')
      || this.router.url.startsWith('/maintenance');
  }

  ngOnInit() { }

  public isDesignTemplateDisplay() {
    return this.permissionService.hasReadPermission(Contents.DESIGN_TEMPLATE)
      || this.permissionService.hasReadPermission(Contents.STANDARD_DESIGN_TEMPLATE);
  }

  public isMasterManagerDisplay() {
    return this.permissionService.hasReadPermission(Contents.TESTER_DEVICE)
      || this.permissionService.hasReadPermission(Contents.DEVICE_MODEL)
      || this.permissionService.hasReadPermission(Contents.DEVICE_MODEL_GROUP)
      || this.permissionService.hasReadPermission(Contents.OPERATING_SYSTEM)
      || this.permissionService.hasReadPermission(Contents.OS_GROUP)
      || this.permissionService.hasReadPermission(Contents.PLATFORM_OS_GROUP)
      || this.permissionService.hasReadPermission(Contents.SDK_VERSION)
      || this.permissionService.hasReadPermission(Contents.SDK_VERSION_GROUP)
      || this.permissionService.hasReadPermission(Contents.PLATFORM_SDK_VERSION_GROUP)
      || this.permissionService.hasReadPermission(Contents.DEAL)
      || this.permissionService.hasReadPermission(Contents.EXCHANGE_RATE)
      || this.permissionService.hasReadPermission(Contents.TOPICS_URL)
      || this.permissionService.hasReadPermission(Contents.AD_REQUEST_PARAMETER_TEMPLATE)
      || this.permissionService.hasReadPermission(Contents.USERS);
  }
}
